// App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavBar from './NavBar.jsx';
import ServicesPage from './ServicesPage.jsx';
import HomePage from './HomePage.jsx';
import Form from './RequestForm.jsx';
import Footer from './Footer.jsx';
import Products from './Products.jsx';
import ContactUS from './Contact.jsx';
import ProductCart from './cart.jsx'; 
import ProjectsPage from './ProjectsPage.jsx';
import Admin from './admin.jsx';
import './app.css'; 


function App() {
  return (
    <div className="page-container">
      <Router>
        <NavBar/>
        <div className="content-wrap">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/Form" element={<Form />} />
            <Route path="/Services" element={<ServicesPage />} />   
            <Route path="/Products" element={<Products />} />   
            <Route path="/Contact" element={<ContactUS />} /> 
            <Route path="/cart" element={<ProductCart />} /> 
            <Route path="/admin" element={<Admin/>}/>
            <Route path="/projects" element={<ProjectsPage/>} />   
          </Routes>
        </div>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
